import { render, staticRenderFns } from "./ViewAdz.admin.vue?vue&type=template&id=18cd341c&scoped=true&"
import script from "./ViewAdz.admin.vue?vue&type=script&lang=js&"
export * from "./ViewAdz.admin.vue?vue&type=script&lang=js&"
import style0 from "./ViewAdz.admin.vue?vue&type=style&index=0&id=18cd341c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cd341c",
  null
  
)

export default component.exports